import styled from "styled-components";
import { LogoFullCu } from "@/components/ui/logo-cu";
import { Colors } from "@/theme";
import { desktop } from "@/theme/common";

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.black};
  width: 100%;
  padding: 64px 16px;
  ${desktop(`
    padding: 72px 80px;
  `)}
`;

/**
 * Footer Component
 */

export const Footer = () => (
  <Container>
    <LogoFullCu size={150} textColor={Colors.white} />
  </Container>
);
